import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const ZipCodeInput = () => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("zipCode")}
      placeholder={t("zipCode")}
      id="zip_code"
      type="text"
      checkType="zip_code"
      autoComplete="zip code"
      required={true}
      attr={{ maxLength: 10, minLength: 5 }}
      errorMsg={[
        { errorMsg: t("zipCodeMinLength"), validation: "minLength" },
        { errorMsg: t("zipCodeInvalid"), validation: "pattern" },
      ]}
    />
  );
};
export default ZipCodeInput;